import React, { useRef } from "react";
import { ClickAwayListener } from "@mui/material";
import styles from "./DropdownContainer.module.scss";

interface propsI {
  onClickOutside?: (event: MouseEvent | TouchEvent) => void;
  className?: string;
  children: React.ReactNode;
}

const DropdownContainer: React.FC<propsI> = ({
  onClickOutside,
  className,
  children,
}) => {
  const dropdownContainerEl = useRef<HTMLDivElement>(null);

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={(e) => onClickOutside?.(e)}
    >
      <div
        className={`${className ? className : styles.defaultStyles} ${
          styles.dropdownContainer
        } `}
        ref={dropdownContainerEl}
      >
        {children}
      </div>
    </ClickAwayListener>
  );
};

export default DropdownContainer;
